module.exports = __webpack_public_path__ + "img/zfb@2x.bde375cf.png";